import { combineReducers } from "redux";
import SchoolReducer from "./SchoolReducer";
import HolidayReducer from "./HolidayReducer";
import MisHolidayReducer from "./MisHolidayReducer";
import DriversReducer from "./DriversReducer";
import VehicleReducer from "./VehicleReducer";
import DashboardReducer from "./DashboardReducer";
import UiReducer from './UiReducer';
import { sessionReducer } from "./session";
import { groupsReducer } from "./groups";
import { devicesReducer } from "./devices";
import { eventsReducer } from "./events";
import { geofencesReducer } from "./geofences";
import { calendarsReducer } from "./calendars";
import { errorsReducer } from "./errors";
import { driversReducer } from "./drivers";
import { maintenancesReducer } from "./maintenances";
import { reportsReducer } from "./reports";
import SMCReducer from "./SMCReducer";
import GlobalSearchReducer from "./GlobalSearchReducer";
import SettingsReducer from "./SettingsReducer";
import CommissionReducer from "./CommissionReducer";
import ReportsReducer from "./ReportsReducer";
import TraccarReducer from "./TraccarReducer";
import ProfileReducer from "./ProfileReducer";
import StudentReducer from "./StudentReducer";
import FeedbackReducer from "./FeebackReducer";
import ImportSchoolsReducer from "./ImportSchoolsReducer";


const RootReducer = combineReducers({
  ui: UiReducer,
  school: SchoolReducer,
  holiday: HolidayReducer,
  Misholiday: MisHolidayReducer,
  dashboard: DashboardReducer,
  driver: DriversReducer,
  vehicle: VehicleReducer,
  session: sessionReducer,
  groups: groupsReducer,
  devices: devicesReducer,
  events: eventsReducer,
  geofences: geofencesReducer,
  calendars: calendarsReducer,
  drivers: driversReducer,
  maintenances: maintenancesReducer,
  errors: errorsReducer,
  trccarReports: reportsReducer,
  traccarDetails: TraccarReducer,
  smc: SMCReducer,
  globalsearch: GlobalSearchReducer,
  settings: SettingsReducer,
  commission: CommissionReducer,
  reports: ReportsReducer,
  profile: ProfileReducer,
  studentDashboardData: StudentReducer,
  feedback: FeedbackReducer,
  importSchools: ImportSchoolsReducer,
});

export default RootReducer;
